module.exports = __webpack_public_path__ + "img/Dantam Makeover 23.87427e0d.jpg";